// extracted by mini-css-extract-plugin
export var inline = "_tp-0";